<script setup>
import { cdnImageUrl } from '@dpgradio/creative'
import QIconEnergetic from '../../../../assets/animations/q_icon_energetic.json'
import CharacterEnlarge from '../text_animations/CharacterEnlarge.vue'
import CharacterJumpFromTheRight from '../text_animations/CharacterJumpFromTheRight.vue'
import TextSlideUp from '../text_animations/TextSlideUp.vue'
import { frames } from '../../../../utils/frames'
const gsapTimeline = useGsapTimeline()

const { withIntro } = defineProps({
  label: String,
  track: Object,
  withIntro: Boolean,
})

const logoElement = ref(null)

const timelineLabel = ref(null)
const timelineTitle = ref(null)
const timelineArtist = ref(null)

const timelineEditionPosition = ref(null)
const timelineEditionListName = ref(null)

const imageElement = ref(null)
const thumbnailPlaceholderElement = ref(null)
onMounted(() => {
  const qIconEnergeticIntro = useLottie(logoElement.value, QIconEnergetic, { color: '#ffffff', renderer: 'svg' })
  const qIconEnergeticPlaceholder = thumbnailPlaceholderElement.value && useLottie(thumbnailPlaceholderElement.value, QIconEnergetic, { color: '#ffffff', renderer: 'svg' })

  const timeline = gsapTimeline({ name: 'TrackFull' })

  if (withIntro) {
    timeline.to(qIconEnergeticIntro.playhead, qIconEnergeticIntro.animation, `<${frames(12)}`).to(logoElement, { scale: 10, y: 1500, duration: frames(4), ease: 'power2.out' }, `<${frames(35)}`)
  } else {
    timeline.delay(frames(16))
  }

  timeline
    .add(timelineLabel, `<${frames(1)}`)
    .add(timelineTitle, `<${frames(3)}`)
    .from(imageElement, { scale: 0, duration: frames(12), ease: 'back.out(1)' }, '<')
    .to(qIconEnergeticPlaceholder?.playhead, qIconEnergeticPlaceholder?.animation || {}, '<')
    .add(timelineArtist, `<${frames(6)}`)
    .add(timelineEditionPosition, `<${frames(5)}`)
    .add(timelineEditionListName, `<${frames(3)}`)
})

const leadingZero = (number) => (number < 10 ? `0${number}` : number)
</script>

<template>
  <div ref="logoElement" class="absolute scale-85 left-0 right-0 -top-96" />
  <div v-if="track" class="h-full flex items-center justify-center space-x-16">
    <div class="h-[550px] w-[550px]">
      <img v-if="track.thumbnail" ref="imageElement" :src="cdnImageUrl(track.thumbnail, 'w800')" class="w-full h-full object-cover rounded-[6rem]" />
      <div v-else ref="thumbnailPlaceholderElement" class="scale-150" />
    </div>
    <div class="text-white space-y-12 w-[800px]">
      <CharacterJumpFromTheRight :text="label" textSizeClass="text-[72px] font-normal" @timeline="timelineLabel = $event" />
      <TextSlideUp :text="track.title" class="text-[105px] font-bold" @timeline="timelineTitle = $event" />
      <TextSlideUp :text="track.artist.name" class="text-[70px] font-normal" @timeline="timelineArtist = $event" />
    </div>
  </div>
  <div v-if="track?.activeEditions?.[0]" class="absolute bottom-0 text-white text-[50px] p-safe space-x-6 flex">
    <CharacterEnlarge :text="`#${leadingZero(track.activeEditions[0].position)}`" class="font-bold" @timeline="timelineEditionPosition = $event" />
    <CharacterEnlarge :text="track.activeEditions[0].list.name" @timeline="timelineEditionListName = $event" />
  </div>
</template>
